import {EditPortfolio} from './edit-portfolio';

export default EditPortfolio;